import { HTTP_METHODS } from './const'
import { request } from './index'

class FAQ {
  static getList(locale = {}) {
    return request({
      url: 'v6/faqs',
      method: HTTP_METHODS.get,
      ...locale,
    })
  }

  static getDetail(id, locale = {}) {
    return request({
      url: `v6/faqs/${id}`,
      method: HTTP_METHODS.get,
      ...locale,
    })
  }
}

export default FAQ
